import React from 'react';
import PropTypes from 'prop-types';

import Input from 'src/app/components/Input';
import { domains } from 'src/app/components/EmailSuggester/emailSuggester.json';
import 'src/app/components/EmailSuggester/EmailSuggester.scss';



const textMeasureElement = document.createElement('span');
textMeasureElement.style.cssText =
  'position: absolute; visibility: hidden; white-space: nowrap; top: 0; pointer-events: none; font-size: 16px;';
document.body.appendChild(textMeasureElement);

class EmailSuggester extends React.Component {
  state = {
    suggestion: '',
    width: 0,
    offsetWidth: 0,
    value: ''
  };

  textMeasureElement = textMeasureElement;

  adjustSuggestion = (value) => {

    if (!value.includes('@')) {
      return '';
    }

    const userInputArray = value.split('@');
    const possibleDomain = userInputArray.pop();

    if (possibleDomain.length === 0) {
      return '';
    }

    // checks if there is such domain in or such part of a domain in domain list
    const suggestedDomain = domains
      .filter((domain) => domain.indexOf(possibleDomain) === 0)
      .shift() || '';

    return suggestedDomain.replace(possibleDomain, '');
  };

  suggestDomain = () => {
    const { inputRef } = this.props;
    const { offsetWidth } = this.state;
    const { value } = inputRef.current;

    const suggestedDomain = this.adjustSuggestion(value);

    this.textMeasureElement.innerText = value + suggestedDomain;
    const fullInputSize = this.textMeasureElement.offsetWidth;

    this.textMeasureElement.innerText = suggestedDomain;
    const domainSize = this.textMeasureElement.offsetWidth;

    this.setState({
      width: this.getDomainSize({ offsetWidth, fullInputSize, domainSize }),
      suggestion: suggestedDomain
    });
  };

  resetSuggestion = () => this.setState(() => ({ suggestion: '', width: 0 }));

  getDomainSize = ({ offsetWidth, fullInputSize, domainSize }) => fullInputSize > offsetWidth ? domainSize : 0;

  // Chrome is not adding spaces to their inputRef by default. It is only chrome behaviour :(
  preventSpaces = (event) => {
    const spaceCode = 32;

    if (event.which === spaceCode) {
      event.preventDefault();
    }
  };

  get suggestedEmail() {
    const { suggestion } = this.state;
    const { value } = this.props;

    return value + suggestion;
  };

  applySuggestedEmail = () => {
    const { suggestedEmail, setInputValue } = this;
    const { pickedEmail } = this.props;

    setInputValue(suggestedEmail);
    pickedEmail(suggestedEmail);
  };

  setInputValue = (value) => {
    // Why? There is race condition when we apply suggested email to reducer and its 'value' property,
    // but then input has not this value in its properties and it is triggering falsy validation even if
    // input is proper
    const { inputRef } = this.props;
    const { current } = inputRef;

    current.value = value;
  };

  onBlur = () => {
    const { suggestion } = this.state;

    if (suggestion.length > 0) {
      this.applySuggestedEmail();
    }
    this.resetSuggestion();

    const { blur, inputRef } = this.props;
    const { current } = inputRef;

    this.setState({ value: current.value, offsetWidth: current.offsetWidth });
    blur({ target: current });
  };

  onFocus = () => {
    const { focus, inputRef } = this.props;
    const { current } = inputRef;

    this.setState({ value: current.value, offsetWidth: current.offsetWidth });

    focus({ target: current });
    this.suggestDomain();
  };

  onChange = () => {
    const { change, inputRef } = this.props;
    const { current } = inputRef;

    this.setState({ value: current.value, offsetWidth: current.offsetWidth });

    change({ target: current });
    this.suggestDomain();
  };

  onKeyDown = (event) => {
    this.preventSpaces(event);
  };

  render() {
    const { inputRef, dataTest } = this.props;
    const { width, suggestion, value } = this.state;
    const { onBlur, onFocus, onChange, onKeyDown } = this;

    return (
      <div styleName="email-suggester">
        <Input required
               style={ { paddingRight: width } }
               type="email"
               maxLength={ 100 }
               minLength={ 5 }
               data-test={ dataTest }
               ref={ inputRef }
               value={ value }
               { ...{
                 onBlur,
                 onFocus,
                 onChange,
                 onKeyDown
               } }
        />

        <div styleName="email-suggester__suggestion">
          <div styleName="suggestion__input-mask">{value}</div>
          <div styleName="suggestion__domain">{suggestion}</div>
        </div>
      </div>
    );
  }
}

EmailSuggester.propTypes = {
  value: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired,
  focus: PropTypes.func.isRequired,
  blur: PropTypes.func.isRequired,
  dataTest: PropTypes.string.isRequired,
  pickedEmail: PropTypes.func.isRequired,
  inputRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired
};

export default EmailSuggester;
